// NPM Modules
import { writable } from 'svelte/store';
import collect from 'collect.js';
// Models
import Track from '@/Models/Track.js';
import TrackClassification from '@/Models/TrackClassification.js';
import RacingProduct from '@/Models/RacingProduct.js';
import BetType from '@/Models/BetType.js';
// Stores
import TrackBetTypeStore from '@/Stores/Racing/TrackBetTypeStore.js';
import BetTypeStore from '@/Stores/Racing/BetTypeStore.js';
import ProductStore from '@/Stores/Racing/ProductStore.js';
import TrackFees from '@/Models/TrackFees.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	const { subscribe, set, update } = writable(collect());

	let meta;

	const methods = {
		getPagination() {
			return meta && meta.pagination;
		},

		getTracks(pagination = null) {
			const track = new Track();

			let results = pagination
				? track.with(['classifications', 'fees']).paginate(pagination.size, pagination.number)
				: track.with(['classifications', 'fees']).get();
			return results
				.then((result) => {
					meta = result.meta;
					set(collect(result.data));
				})
				.catch((e) => {
					console.error(e);
				});
		},

		getTrackWithBetTypes(id) {
			const product = new RacingProduct();
			const betType = new BetType();
			const track = new Track();
			let allTrackBetTypes = collect();

			let allProducts = product.get().then((result) => {
				ProductStore.set(result.data);
			});

			let allBetTypes = betType.get().then((result) => {
				BetTypeStore.set(result.data);
			});

			let trackData = track
				.with(['bet_types'])
				.find(id)
				.then((result) => {
					result.bet_types.data.map((betType) => {
						betType.track_id = result.id;
						allTrackBetTypes.push(betType);
					});
					TrackBetTypeStore.set(allTrackBetTypes);

					delete result.bet_types;
					set(collect([result]));
				})
				.catch((e) => {
					console.error(e);
				});

			return Promise.all([allProducts, allBetTypes, trackData]);
		},

		updateTrackClassifications(trackId, payload) {
			const trackClassification = new TrackClassification();

			return trackClassification.update(trackId, payload);
		},

		updateTrackFees(trackId, payload) {
			const trackFees = new TrackFees();

			return trackFees.update(trackId, payload);
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
